import React from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import Ojk from '/Images/OJK_Logo.png';
import Bappebti1 from '/Images/bappebti.svg';
import Bapepti from "/Images/logo 27701 PT Tennet 1.svg";
import Kominfo2 from "/Images/logo PT TENNET 1.svg";

const Solution = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      backgroundColor: '#E7E4E2',
      padding: isMobile ? '2rem 1rem' : '3rem 0',
      fontFamily: 'Poppins',
    },
    title: {
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #2D669B 0%, #0582CA 100%)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
      marginBottom: '2rem',
      fontSize: isMobile ? '30px' : '40px',
      fontFamily: "Poppins"
    },
    cardContainer: {
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'space-around',
      gap: '1.5rem',
      flexWrap: 'wrap',
      flexDirection: isMobile ? 'column' : 'row',
    },
    card: {
      flex: '1 1 30%',
      padding: isMobile ? '1.5rem' : '2rem',
      textAlign: 'center',
      backgroundColor: '#E7E4E2',
      marginBottom: isMobile ? '1.5rem' : '0',
    },
    logo: {
      maxWidth: isMobile ? '150px' : '200px',
      minHeight: isMobile ? "120px" : "162px",
      marginBottom: '1rem',
    },
    cardTitle: {
      color: '#214D73',
      fontWeight: 'bold',
      fontSize: isMobile ? '16px' : '18px',
      marginBottom: '0.5rem',
    },
    cardText: {
      maxWidth: isMobile ? '250px' : '280px',
      margin: '0 auto',
      fontSize: isMobile ? '14px' : '16px',
      color: '#6D6D6D',
    },
  };

  return (
    <section style={styles.container}>
      <Container style={{ textAlign: 'center' }}>
        {/* Title */}
        <Typography variant="h4" align="center" gutterBottom style={styles.title}>
          Compliance and Certifications
        </Typography>

        {/* Card Layout */}
        <Box style={styles.cardContainer}>
          {/* Card 1 */}
          <Box
            style={{
              ...styles.card,
              minHeight: isMobile ? 270 : 340,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <Box
              sx={{
                width: isMobile ? 150 : 200,
                height: isMobile ? 120 : 162,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                overflow: 'hidden'
              }}
            >
              <img
                src={Ojk}
                alt="Ojk_logo"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                  margin: '0 auto'
                }}
              />
            </Box>
            <Typography variant="h6" style={styles.cardTitle}>
              Licensed by OJK
            </Typography>
            <Typography style={styles.cardText}>
              Licensed by OJK for digital financial asset custody.
            </Typography>
          </Box>

          {/* Card 2 */}
          <Box style={{ ...styles.card, minHeight: isMobile ? 270 : 340, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img src={Bappebti1} alt="Bappebti" style={styles.logo} />
            <Typography variant="h6" style={styles.cardTitle}>
              Licensed by BAPPEBTI
            </Typography>
            <Typography style={styles.cardText}>
              Licensed by BAPPEBTI for secure, compliant asset custody.
            </Typography>
          </Box>

          {/* Card 3 */}
          <Box style={{ ...styles.card, minHeight: isMobile ? 270 : 340, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img src={Bapepti} alt="ISO 27701" style={styles.logo} />
            <Typography variant="h6" style={styles.cardTitle}>
              ISO/IEC 27701:2019
            </Typography>
            <Typography style={styles.cardText}>
              Certified for enhanced privacy and data protection.
            </Typography>
          </Box>

          {/* Card 4 */}
          <Box style={{ ...styles.card, minHeight: isMobile ? 270 : 340, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img src={Kominfo2} alt="ISO 27001" style={styles.logo} />
            <Typography variant="h6" style={styles.cardTitle}>
              ISO/IEC 27001:2022
            </Typography>
            <Typography style={styles.cardText}>
              Certified for top-tier information security management.
            </Typography>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default Solution;
